// import React, { useState } from 'react';
// import { useLocation, useParams } from 'react-router-dom';
// import { QRCodeSVG } from 'qrcode.react';

// const FoodBuyPage = () => {
//   const { productName } = useParams();
//   const { state } = useLocation();
//   const { price } = state || {};
  
//   const [form, setForm] = useState({ name: '', email: '', method: 'Credit Card' });
//   const [submitted, setSubmitted] = useState(false);

//   const upiID = 'gyasuddinali@cnrb'; // Replace with your real UPI ID
//   const upiURL = `upi://pay?pa=${upiID}&pn=OneStopService=${price}&cu=INR`;

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setSubmitted(true);
//   };

//   if (submitted) {
//     return (
//       <div style={{ padding: '40px', textAlign: 'center' }}>
//         <h2>Thank you for your purchase!</h2>
//         <p>You’ve successfully bought <strong>{productName}</strong> for <strong>{price}</strong>.</p>
//       </div>
//     );
//   }

//   return (
//     <div style={{ maxWidth: '500px', margin: '40px auto', padding: '20px', border: '1px solid #ccc', borderRadius: '10px' }}>
//       <h2 style={{ textAlign: 'center' }}>Buy: {productName}</h2>
//       <p style={{ textAlign: 'center', fontWeight: 'bold' }}>Price: ₹{price}</p>

//       <form onSubmit={handleSubmit}>
//         <div style={{ marginBottom: '15px' }}>
//           <label>Name:</label>
//           <input
//             type="text"
//             name="name"
//             required
//             onChange={handleChange}
//             style={{ width: '100%', padding: '8px' }}
//           />
//         </div>

//         <div style={{ marginBottom: '15px' }}>
//           <label>Email:</label>
//           <input
//             type="email"
//             name="email"
//             required
//             onChange={handleChange}
//             style={{ width: '100%', padding: '8px' }}
//           />
//         </div>

//         <div style={{ marginBottom: '15px' }}>
//           <label>Payment Method:</label>
//           <select
//             name="method"
//             value={form.method}
//             onChange={handleChange}
//             style={{ width: '100%', padding: '8px' }}
//           >
//             <option value="Credit Card">Credit Card</option>
//             <option value="UPI">UPI</option>
//             <option value="Net Banking">Net Banking</option>
//             <option value="Cash on Delivery">Cash on Delivery</option>
//           </select>
//         </div>

//         {form.method === 'UPI' && (
//           <div style={{ textAlign: 'center', marginBottom: '20px' }}>
//             <p><strong>Scan to Pay via UPI</strong></p>
//             <QRCodeSVG value={upiURL} size={180} />
//             <p style={{ marginTop: '10px', fontSize: '14px', color: '#555' }}>UPI ID: <strong>{upiID}</strong></p>
//           </div>
//         )}

//         <button
//           type="submit"
//           style={{
//             width: '100%',
//             padding: '10px',
//             backgroundColor: '#007bff',
//             color: 'white',
//             border: 'none',
//             borderRadius: '5px',
//             cursor: 'pointer',
//           }}
//         >
//           Pay Now
//         </button>
//       </form>
//     </div>
//   );
// };

// export default FoodBuyPage;







import React, { useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';

const FoodBuyPage = () => {
  const { productName } = useParams();
  const { state } = useLocation();
  const { price } = state || {};

  const [form, setForm] = useState({
    name: '',
    email: '',
    method: 'Credit Card',
    phone: '',
    address: '',
  });

  const [submitted, setSubmitted] = useState(false);
  const [copied, setCopied] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState('Unpaid');

  const upiID = 'gyasuddinali@cnrb';
  const businessName = 'OneStopService';
 const upiURL = `upi://pay?pa=${encodeURIComponent(upiID)}&pn=${encodeURIComponent(businessName)}&am=${price}&cu=INR`;


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const copyUPI = () => {
    navigator.clipboard.writeText(upiID).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);

    // Save to localStorage
    const orderData = {
      ...form,
      productName,
      price,
      paymentStatus,
      date: new Date().toISOString(),
    };

    const orders = JSON.parse(localStorage.getItem('orders') || '[]');
    orders.push(orderData);
    localStorage.setItem('orders', JSON.stringify(orders));
  };

  if (submitted) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <h2>✅ Thank you for your purchase!</h2>
        <p>
          You've successfully ordered <strong>{productName}</strong> for{' '}
          <strong>₹{price}</strong>.
        </p>
        <p>
          Payment Status: <strong>{paymentStatus}</strong>
        </p>
      </div>
    );
  }

  return (
    <div
      style={{
        maxWidth: '550px',
        margin: '40px auto',
        padding: '20px',
        border: '1px solid #ccc',
        borderRadius: '10px',
        backgroundColor: 'white',
      }}
    >
        <h1 className='text-danger text-center'>Do not pay any money</h1>
      <h2 className='text-dark' style={{ textAlign: 'center' }}>Buy: {productName}</h2>
      <p className='text-dark' style={{ textAlign: 'center', fontWeight: 'bold' }}>Price: ₹{price}</p>

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '15px' }}>
          <label className='text-dark'>Name:</label>
          <input
            type="text"
            name="name"
            required
            value={form.name}
            onChange={handleChange}
            style={{ width: '100%', padding: '8px' }}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label className='text-dark'>Email:</label>
          <input
            type="email"
            name="email"
            required
            value={form.email}
            onChange={handleChange}
            style={{ width: '100%', padding: '8px' }}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label className='text-dark'>Phone:</label>
          <input
            type="tel"
            name="phone"
            required
            value={form.phone}
            onChange={handleChange}
            style={{ width: '100%', padding: '8px' }}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label className='text-dark'>Address:</label>
          <textarea
            name="address"
            required
            value={form.address}
            onChange={handleChange}
            style={{ width: '100%', padding: '8px' }}
            rows={3}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label  className='text-dark'>Payment Method:UPI&Cash</label>
          <select
            name="method"
            value={form.method}
            onChange={handleChange}
            style={{ width: '100%', padding: '8px' }}
          >
            <option value="Credit Card">Credit Card</option>
            <option value="UPI">UPI</option>
            {/* <option value="Net Banking">Net Banking</option> */}
            <option value="Cash on Delivery">Cash on Delivery</option>
          </select>
        </div>

        {form.method === 'UPI' && (
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <p className='text-dark'><strong>Scan to Pay via UPI</strong></p>
            <QRCodeSVG value={upiURL} size={180} />
            <p style={{ marginTop: '10px', fontSize: '14px' }}>
              UPI ID: <strong className='text-dark'>{upiID}</strong>{' '}
              <button
                type="button"
                onClick={copyUPI}
                style={{
                  marginLeft: '10px',
                  padding: '4px 8px',
                  fontSize: '12px',
                  cursor: 'pointer',
                }}
              >
                {copied ? 'Copied!' : 'Copy'}
              </button>
            </p>
          </div>
        )}

        <div style={{ marginBottom: '20px' }}>
          <label>Payment Status:</label>
          <select
            value={paymentStatus}
            onChange={(e) => setPaymentStatus(e.target.value)}
            style={{ width: '100%', padding: '8px' }}
          >
            <option value="Unpaid">Unpaid</option>
            <option value="Paid">Paid</option>
          </select>
        </div>

        <button
          type="submit"
          style={{
            width: '100%',
            padding: '10px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
        >
          Pay Now
        </button>
      </form>
    </div>
  );
};

export default FoodBuyPage;
